<template>
  <div class="Pos_main">
    <div class="pos_all">
      <div class="all_nav">
        <p class="posJieInfo">* 全阶段: 5月24号-6月20号</p>
        <!-- <p class="posJieInfo" v-else>* 全阶段: 11月04号-11月11号(数据更新完毕)</p> -->
        <p v-if="upFlag==1">
          全网总销售 -{{ updataTime1.substring(5).replace("-", "月") }}日
          <!-- 全网总销售(现货) -11月11日24:00(更新完成) -->
          <!--  -->
        </p>
        <p v-else>
          全网总销售 -{{ updataTime1.substring(5).replace("-", "月") }}日
          <!-- 全网总销售(现货) -11月11日24:00(更新完成) -->
        </p>
        <!-- <span>更新时间：{{updataTime1}}</span> -->
      </div>
      <PosAll :upTime="updataTime1.substring(5)"></PosAll>
    </div>
    <div class="pos_Tmall">
      <div class="Tmall_nav">
        <p v-if="upTmFlag==1">
          <!-- TmallFs总销售额(现货) -11月11日24:00(更新完成) -->
          Tmall旗舰店总销售 -{{ updataTime2.substring(5).replace("-", "月") }}日
          <!--  -->
        </p>
        <p v-else>
          Tmall旗舰店总销售 -{{ updataTime1.substring(5).replace("-", "月") }}日
          <!-- TmallFs总销售额(现货) -11月11日24:00(更新中) -->
        </p>
        <!-- <span>更新时间：{{updataTime2}}</span> -->
      </div>
      <PosTmall :upTime="updataTime2.substring(5)"></PosTmall>
    </div>
    <div class="Full_stage">
      <div class="stage_nav">
        <p>618全阶段目标完成率（5月24日-6月20日） </p>
        <!-- <p>全网618第一波目标完成率（5月24日-6月3日）</p> -->
        <span></span>
      </div>
      <PosFull @getTime="getUpdateTime"></PosFull>
    </div>
  </div>
</template>
<script>
import PosAll from "@/components/Pos/pos_all";
import PosFull from "@/components/Pos/pos_FullStage";
import PosTmall from "@/components/Pos/pos_Tmall";

export default {
  name: "Pos",
  data() {
    return {
      updataTime1: "10-20",
      updataTime2: "05-20",
      upFlag:0,
      upTmFlag:0
    };
  },
  methods: {
    getUpdateTime(data) {
      this.updataTime1 = data.allTime;
      this.upFlag=data.upDataFlag
      this.upTmFlag=data.upDataTmallFlag
      this.updataTime2 = data.TmallFsTime;
    },
  },
  components: {
    PosAll,
    PosFull,
    PosTmall,
  },
  beforeMount() {},
};
</script>
<style  scoped>
.Pos_main {
  position: relative;
  left: 0;
  min-height: 740px;
  width: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.Pos_main .all_nav,
.Pos_main .Tmall_nav,
.Pos_main .stage_nav {
  position: relative;
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #d1534b;
  border-radius: 22.5008px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Pos_main .all_nav {
  margin: 28.8px 20px 0px 16px;
}
.Pos_main .Tmall_nav {
  margin: 0px 20px 0px 16px;
}
.Pos_main .stage_nav {
  margin: 0px 20px 10px 16px;
}

.Pos_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "PingFangSC-Medium";
  font-size: 16px;
  color: #ffffff;
}

.Pos_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  opacity: 0.6;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
  margin-right: 15px;
}
.Pos_main .pos_all {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin: 0 auto;
}
.posJieInfo {
  position: absolute;
  font-family: "PingFangSC-Medium";
  top: -70%;
  right:0;
  height: 20px;
  min-width: 60px;
  background: #d1534b;
  z-index: 99;
  padding: 3px 8px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: "PingFangSC-Medium";
  font-size: 14px !important;
  color:#f3f3f3 !important;
  text-align: center;
}
.pos_all {
  overflow: hidden;
  height: 200px;
}
.pos_Tmall {
  overflow: hidden;
}
.Full_stage {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/Pos/Pos.vue